import {TSBerechtigung} from './enums/TSBerechtigung';
import {PageNameConstants} from '../core/service/PageNameConstants';

/**
 * Berechtigungsmap fuer alle Pages. Es gibt jeweils verschiedene maps fuer die verschiedenen Rollen in den verschiedenen status
 */
export default class TSBerechtigungInView {

    private _map: Map<string, TSBerechtigung> = new Map<string, TSBerechtigung> ();

    constructor(gesucherstellen: TSBerechtigung, schaetzung: TSBerechtigung, aufwaende: TSBerechtigung, auszahlung: TSBerechtigung, bemerkung: TSBerechtigung,
                pageNames: PageNameConstants) {

        /** wurde mit FS-706 mit schaetzung: TSBerechtigung erweitert
         * siehe auch:
         * dv-gesuch-navigation.ts
         * Berechtigungsservice.ts
         */

        this._map.set(pageNames.GESUCHERSTELLEN, gesucherstellen);
        this._map.set(pageNames.SCHADENMELDUNG, gesucherstellen);

        this._map.set(pageNames.SCHAETZUNG, schaetzung);

        this._map.set(pageNames.EIGENLEISTUNGEN, aufwaende);
        this._map.set(pageNames.VORLEISTUNG, aufwaende);
        this._map.set(pageNames.VORLEISTUNG, schaetzung);
        this._map.set(pageNames.FREMDKOSTEN, aufwaende);
        this._map.set(pageNames.FREMDKOSTEN, schaetzung);

        this._map.set(pageNames.AUFWAENDE, aufwaende);
        this._map.set(pageNames.BANKKONTO, aufwaende);

        this._map.set(pageNames.BEITRAG, auszahlung);
        this._map.set(pageNames.ENTSCHAEDIGUNG, auszahlung);

        this._map.set(pageNames.BEMERKUNG, bemerkung);
    }

    public getTSBerechtigung(pageName: string): TSBerechtigung {
        let tsBerechtigung: TSBerechtigung | undefined = this._map.get(pageName);
        if (tsBerechtigung) {
            return tsBerechtigung;
        } else {
            console.debug('the passed page name has no known Berechtigung: ', pageName);
            return TSBerechtigung.NO_ACCESS;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSBerechtigungInView.ts